/** Shared external URLs used across the site */
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.orthodox.zimare';

/** Debre Efrata (Ephrata) St. Mary Church — Jimma; t=k = satellite */
export const CHURCH_MAP_EMBED_URL =
  'https://maps.google.com/maps?q=7.6664207,36.8297124+(Debre+Efrata+Saint+Mary+Church)&z=19&hl=en&t=k&output=embed';

/** Opens Google Maps turn-by-turn directions to the church */
export const CHURCH_DIRECTIONS_URL =
  'https://www.google.com/maps/dir/?api=1&destination=7.6664207,36.8297124&travelmode=driving';
